import gsap from 'gsap';
import timeoutPromise from '../../helpers/timeoutPromise';

export default {
  namespace: 'about',

  enter() {
    const timeline = document.querySelector('.about-timeline');

    if (timeline) {
      const items = timeline.children;

      gsap.set(timeline, {
        opacity: 0,
      });

      gsap.set(items, {
        y: 20,
        opacity: 0,
      });

      gsap.to(items, {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: 0.75,
        ease: 'power1.out',
        stagger: 0.2,
      });

      gsap.to(timeline, {
        opacity: 1,
        duration: 1,
        ease: 'power1.out',
      });

      return timeoutPromise(200);
    }

    return Promise.resolve();
  },
};
